import { useState, InputHTMLAttributes } from 'react';

interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  height?: 40 | 48;
}

const SearchInput = ({
  value,
  onChange,
  placeholder = 'Поиск...',
  height = 40,
  disabled = false,
  className = '',
  ...rest
}: SearchInputProps) => {
  const [focused, setFocused] = useState(false);
  const showClear = focused && value.length > 0;

  return (
    <div className={`relative ${className}`}>
      <input
        {...rest}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        disabled={disabled}
        className={[
          'w-full px-3 border rounded-[10px] text-[14px] font-montserrat font-normal text-[#141414]',
          'placeholder:text-[#9DA7B5] bg-white outline-none transition-all duration-200',
          height === 40 ? 'h-[40px]' : 'h-[48px]',
          showClear ? 'pr-9' : '',
          focused
            ? 'border-[#3B82F6] shadow-[0_0_0_4px_rgba(59,130,246,0.15)]'
            : 'border-[#D0D3D8]',
          disabled ? 'opacity-50 cursor-not-allowed' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      />
      {showClear && (
        <button
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            onChange('');
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-[18px] h-[18px] rounded-full bg-[#D1D5DB] flex items-center justify-center text-[#6B7280] hover:bg-[#B0B7C3] cursor-pointer border-0 leading-none text-xs"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SearchInput;
